import React, { useEffect, useState } from "react"
import PropTypes, { number } from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"

const RegisterBar = props => {
    const [numberArr, setNumberArr] = useState([])

    const { circleNumber, color, size, shape, fontColor, fontSize, actionNumber, title, titleColor, className } = props;

    useEffect(()=>{
        let newNumberArr = []
        newNumberArr.length = circleNumber
        for (let i = 0; i < circleNumber; i++) {
            newNumberArr[i] = i + 1
        }
        setNumberArr(newNumberArr)
    }, [circleNumber])

    return (
        <div className={className}>
            <div style={{ width: 'fit-content', height: 'fit-content', margin: '0 auto', display: "flex", alignItems: "center" }}>
                {numberArr && numberArr.map((item, index)=>{return (
                    <>
                        {actionNumber === item ?
                            <div style={{borderRadius: shape === 'square' ? 0 : '50%', width: size ? size : 28, height: size ? size : 28, backgroundColor: color ? color : "#4DBBAA", marginLeft: index !== 0 && 8, textAlign: "center"}}>
                                <p style={{fontSize: fontSize ? fontSize : 14, color: fontColor ? fontColor : "white", lineHeight: size ? `${size}px` : '28px', fontWeight: "bold" }}>{item}</p>
                            </div>
                            :
                            <div style={{borderRadius: shape === 'square' ? 0 : '50%', width: 12, height: 12, backgroundColor: color ? color : "#4DBBAA", opacity: item < actionNumber ? 1 : 0.4, marginLeft: index !== 0 && 8}}></div>
                        }

                        {item !== numberArr.length &&
                            <div style={{borderRadius: shape === 'square' ? 0 : '50px', width: 24, height: 3, backgroundColor: color ? color : "#4DBBAA", opacity: item < actionNumber ? 1 : 0.4, marginLeft: 8}}></div>
                        }
                    </>
                )})}
            </div>
            {title && <p style={{fontSize: fontSize ? fontSize : 14, color: titleColor ? titleColor : "#333", fontWeight: "bold", textAlign: "center", marginTop: 8, marginBottom: 0}}>{title}</p>}
        </div>
    )
}

RegisterBar.propTypes = {
    circleNumber: PropTypes.number.isRequired, // 도형의 갯수
    actionNumber: PropTypes.number.isRequired, // 강조될 도형이 몇 번째 도형인지
    shape: PropTypes.string, // 도형의 모양, default는 원
    width: PropTypes.number, // 도형의 너비, default는 28
    color: PropTypes.string, // 도형의 색상, default는 #4DBBAA
    fontSize: PropTypes.number, // 도형 안 텍스트 크기, default는 14
    fontColor: PropTypes.string, // 도형 안 텍스트 색상, default는 white
    title: PropTypes.string, //바 아래 들어갈 문구, default는 공백
    titleColor: PropTypes.string, //타이틀 색상, default는 #333333
  };

export default RegisterBar